<template>
  <v-card class="fill-height rounded-lg d-flex flex-column">
    <v-card-title class="pa-6 d-flex justify-space-between">
      <div class="subtitle-2 grey--text text--grey-100">
        {{ $t('card_title.tsa') }}
      </div>
      <v-btn
        v-if="removable"
        icon
        style="pointer-events: auto"
        @click="$emit('remove')"
      >
        <v-icon small>
          fal fa-times
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="flex-grow-1 d-flex align-center justify-center">
      <v-progress-circular
        :value="tsaValue"
        :size="200"
        :width="25"
        :rotate="-90"
        :color="getColorForValue(tsaValue, 100)"
      >
        <div class="text-h4 font-weight-bold">
          {{ tsaValue }}%
        </div>
      </v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import { getColorForValue } from '@/utils/helpers'

export default {
  name: 'TsaChart',
  props: {
    stats: {
      type: [Object, Array],
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tsaValue() {
      return this.removable ? 66 : this.stats?.tsa?.norm_super_comp_value || 0
    }
  },
  methods: {
    getColorForValue
  }
}
</script>
